<template>
  <section class="p_check_c">
    <el-row class="p_check_row">
      <el-col :span="8">
        <div id="modelView" ></div>
      </el-col>
      <el-col :span="16" class="p_check_r">
        <CheckGantt v-if="ganttVisible" :data="model2" :scheduled-id="scheduledId2"></CheckGantt>
      </el-col>
    </el-row>
  </section>
</template>

<script>
  import {detailModel} from '../../api/api'
  import CheckGantt from "./CheckGantt"
  export default {
    name: "CheckEngine",
    components: {CheckGantt},
    data() {
      return {
        model2: {},
        scheduledId2: null,
        modelId:null,
        proId:null,
        ganttVisible:false
      }
    },
    methods:{

    },
    created(){
      let modelId = this.GLOBAL.getURLParam('modelId');
      let scheduledId = this.GLOBAL.getURLParam('scheduledId');
      let proId = this.GLOBAL.getURLParam('proId');
      this.scheduledId2 = scheduledId;
      this.proId = proId;
      this.modelId = modelId;
    },
    mounted() {

      detailModel({id: this.modelId}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.model2 = result.data;
          this.model2.proId = this.model2.projectId;
          this.model2.modelId = this.model2.id;
          let index = this.model2.modelUrl.lastIndexOf('/');
          let file = this.model2.modelUrl.substring(index + 1, this.model2.modelUrl.length - 4);
          let tokenId = this.model2.id;
          EngineInit("modelView");	// 加载模型
          AddModel("http://121.40.229.90:83/" + file + "/" + file + "List.json", tokenId, true);
          this.ganttVisible = true;
        }
      });
    },
    destroyed() {
      gantt.destructor();
    }
  }
</script>

<style scoped>

  #modelView {
    position: relative;
    width: 100%;
    height:  349px;
  }
  .p_check_c {
    height: 100%;
    overflow-y: hidden;
  }
  .p_check_row{
    height: 100%;
  }
  .p_check_r{
    height: 349px;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/progress/CheckEngine.vue